import React, { useEffect } from 'react';
import AdvancedTrainingSearch from '../../components/common/AdvancedTrainingSearch';

const TrainingCatalogPage: React.FC = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <AdvancedTrainingSearch />;
};

export default TrainingCatalogPage; 